import Column from 'bloko/blocks/column';
import { H2 } from 'bloko/blocks/header';
import VSpacing from 'bloko/blocks/vSpacing';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { GbbColumns } from 'src/components/Price/Gbb';
import TariffCard from 'src/components/Price/TariffCard';
import translation from 'src/components/translation';
import { useSelectorNonNullable } from 'src/hooks/useSelector';

import TariffCardComponent from 'src/pages/PriceZp/components/TariffCardComponent';
import TariffControls from 'src/pages/PriceZp/components/TariffControls';
import TariffFeatures from 'src/pages/PriceZp/components/TariffFeatures';

const TrlKeys = {
    backofficeTariffsTitle: 'price.backofficeTariffsTitle',
};

const TabContent: TranslatedComponent = ({ trls }) => {
    const tariffNames = useSelectorNonNullable(({ priceZp }) => priceZp.tariffNames || []);
    const tariffs = useSelectorNonNullable(({ priceZp }) => priceZp.tariffs);
    const backofficeTariffNames = useSelectorNonNullable(({ priceZp }) => priceZp.backofficeTariffNames || []);
    const backofficeTariffs = useSelectorNonNullable(({ priceZp }) => priceZp.backofficeTariffs);

    return (
        <>
            <GbbColumns>
                {tariffNames.map((tariffName) => (
                    <TariffCardComponent key={tariffName} tariffName={tariffName} tariff={tariffs[tariffName]} />
                ))}
            </GbbColumns>
            {!!backofficeTariffNames.length && (
                <>
                    <Column xs="4" s="8" m="12" l="12">
                        {!!tariffNames.length && <VSpacing base={14} />}
                        <H2>{trls[TrlKeys.backofficeTariffsTitle]}</H2>
                        <VSpacing base={8} />
                    </Column>
                    <GbbColumns>
                        {backofficeTariffNames.map((tariffName) => (
                            <TariffCard
                                key={tariffName}
                                tariff={backofficeTariffs[tariffName]}
                                features={<TariffFeatures tariff={backofficeTariffs[tariffName]} />}
                                controls={<TariffControls tariff={backofficeTariffs[tariffName]} />}
                            />
                        ))}
                    </GbbColumns>
                </>
            )}
        </>
    );
};

export default translation(TabContent);
